import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider, useAuth } from 'src/features/auth/contexts/AuthContext';
import LinkAccount from 'src/features/auth/components/LinkAccount';

type LinkAccountSearch = {
  next?: string;
};

export const Route = createFileRoute('/_auth/link-account')({
  head: () => ({
    meta: [{ title: 'Link Account | Tekst' }],
  }),
  component: LinkAccountPage,
  validateSearch: (search: Record<string, unknown>): LinkAccountSearch => ({
    next: typeof search.next === 'string' ? search.next : undefined,
  }),
});

function LinkAccountPage() {
  return (
    <AuthProvider>
      <LinkAccountContent />
    </AuthProvider>
  );
}

function LinkAccountContent() {
  const { user } = useAuth();
  const { next } = Route.useSearch();

  return <LinkAccount email={user?.email} redirectUrl={`/login?next=${next ?? ''}`} className="w-[450px]" />;
}
